<!-- Start Navbar Area -->
<div class="navbar-area {{navbarClass}}">
    <div class="karlson-nav">
        <div class="container">
            <nav class="navbar navbar-expand-lg navbar-light">
                <a class="navbar-brand" routerLink="/"><img src="assets/img/logo.png" alt="logo"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Accueil
                            </a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLink="/about" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                A propos de nous
                            </a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLink="/services" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Services
                            </a>
                        </li>
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" routerLink="/realisations" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Nos réalisations
                            </a>
                        </li>
                        <li class="nav-item">
                            <a routerLink="/contact" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="nav-link">Contact</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</div>
<!-- End Navbar Area -->